import { useIntl } from 'react-intl';

import { IconOtherServices } from '@xing-com/icons';
import { usePopOver } from '@xing-com/pop-over';

import { ProductsMenuItem } from './products-menu-item';
import {
  StyledIconWithBadge,
  StyledMenu,
  StyledTitle,
  StyledLink,
  ProductsWrapper,
} from './products-menu.styles';

type ProductsMenuWithItemsProps = {
  isLoggedOut: boolean;
};

export const ProductsMenuWithItems: React.FC<ProductsMenuWithItemsProps> = ({
  isLoggedOut,
}) => {
  const { formatMessage } = useIntl();

  return (
    <ProductsMenu isLoggedOut={isLoggedOut}>
      <ProductsMenuItem
        link={{
          href: 'https://recruiting.xing.com',
          title: formatMessage({
            id: 'MAINNAV_BUSINESS_SOLUTIONS_RECRUITING',
          }),
          tracking: {
            sc_o: 'navigation_business_solutions_recruiting',
          },
        }}
      />
      <ProductsMenuItem
        link={{
          href: 'https://werben.xing.com',
          title: formatMessage({
            id: 'MAINNAV_BUSINESS_SOLUTIONS_ADVERTISING',
          }),
          tracking: {
            sc_o: 'navigation_business_solution_advertise',
          },
        }}
      />
    </ProductsMenu>
  );
};

type ProductsMenuProps = {
  isLoggedOut: boolean;
};

const ProductsMenu: React.FC<React.PropsWithChildren<ProductsMenuProps>> = ({
  children,
  isLoggedOut,
}) => {
  const popOver = usePopOver();

  const { formatMessage } = useIntl();

  return (
    <ProductsWrapper
      onMouseLeave={popOver.handleHide}
      onMouseEnter={popOver.handleShow}
    >
      <StyledLink
        to={'https://www.xing.com/business-solutions'}
        $isActive={false}
        data-testid="frame-vnav-business-solutions-menu"
      >
        <StyledIconWithBadge icon={IconOtherServices} />
        <StyledTitle $isLoggedOut={isLoggedOut}>
          {formatMessage({ id: 'MAINNAV_PRODUCTS' })}
        </StyledTitle>
        <StyledMenu
          data-testid="BusinessSolutionsDropDown"
          isInFlow
          isStatic
          show={popOver.show}
        >
          {children}
        </StyledMenu>
      </StyledLink>
    </ProductsWrapper>
  );
};
